import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import BlogPage from './pages/BlogPage'
import Header from './components/Header';
import Footer from './components/Footer'
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import CvPage from './pages/CvPage';
import MarkdownArticle from './pages/MarkdownArticle';
import ResearchPage from './pages/ResearchPage';


function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cv" element={<CvPage />} />
        <Route path="/detailed-cv" element={<CvPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:fileName" element={<MarkdownArticle />} />
        <Route path="/research" element={<ResearchPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
